// extracted by mini-css-extract-plugin
export default {"addRoleButton":"ExternalRolesConfig_addRoleButton__a+0uo","PopoverContent":"ExternalRolesConfig_PopoverContent__BnSUj"};